import React, { useState } from 'react';
import { Tabs, Tab, Typography, Box, Paper, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TokenTrades from './TokenTrades.component';
import TokenAnalytics from "./TokenAnalytics.component";
import BubbleChartComponent from './TokenBubbleChart.component';
import TokenComments from './TokenComments.components';



// --- THEMED TAB PANEL COMPONENT ---

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    const theme = useTheme();

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${ index }`}
            aria-labelledby={`tab-${ index }`}
            {...other}
        >
            {value === index && (
                <Box
                    sx={{
                        p: 3,
                        backgroundColor: theme.palette.background.default,
                        color: theme.palette.text.primary,
                        minHeight: '200px'
                    }}
                >
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `tab-${ index }`,
        'aria-controls': `tabpanel-${ index }`,
    };
}

// --- REFACTORED AND THEMED TOKEN TABS COMPONENT ---

function TokenTabs({ tokenId }) {
    const { t } = useTranslation();
    const theme = useTheme();
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const tabLabels = [t('token.trades'), t('token.comments'), t('token.tradersAnalytics'), t('token.holdersConnections')];

    return (
        // Use theme colors instead of hardcoded values
        <Paper sx={{ width: '100%' }}>
            <Tabs
                value={value}
                onChange={handleChange}
                textColor="primary"
                indicatorColor="primary"
                centered
            >
                {tabLabels.map((label, index) => (
                    <Tab
                        key={index}
                        label={label}
                        {...a11yProps(index)}
                    />
                ))}
            </Tabs>

            <TabPanel value={value} index={0}>
                <TokenTrades tokenId={tokenId} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <TokenComments tokenId={tokenId} />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <TokenAnalytics tokenId={tokenId} />
            </TabPanel>
            <TabPanel value={value} index={3}>
                <BubbleChartComponent tokenId={tokenId} />
            </TabPanel>
        </Paper>
    );
}

export default TokenTabs;